import { useEffect, useState } from 'react'

const CONSENT_KEY = 'artcustom_cookie_consent'

const CookieConsent = () => {
  const [visible, setVisible] = useState(false)
  const [showTerms, setShowTerms] = useState(false)

  useEffect(() => {
    const accepted = localStorage.getItem(CONSENT_KEY)
    if (!accepted) setVisible(true)
  }, [])

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted')
    setVisible(false)
    setShowTerms(false)
  }

  if (!visible) return null

  return (
    <>
      <div
        role="dialog"
        aria-labelledby="cookie-consent-title"
        aria-describedby="cookie-consent-desc"
        className="fixed bottom-0 left-0 right-0 z-[70] p-4 sm:p-6"
      >
        <div className="container mx-auto max-w-4xl">
          <div className="rounded-2xl border border-gray-200/80 bg-white shadow-2xl p-5 sm:p-6">
            <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
              <div className="flex-1">
                <p
                  id="cookie-consent-title"
                  className="text-sm font-semibold text-gray-900 mb-1"
                >
                  Cookies e termos de uso
                </p>
                <p id="cookie-consent-desc" className="text-sm text-gray-600 leading-relaxed">
                  Utilizamos cookies e dados de navegação para melhorar sua experiência,
                  analisar o tráfego e personalizar conteúdos. Ao continuar, você concorda
                  com nossos{' '}
                  <button
                    type="button"
                    onClick={() => setShowTerms(true)}
                    className="font-medium text-[#0877c5] hover:text-[#b51625] underline underline-offset-2 transition-colors"
                  >
                    Termos de Uso e Política de Privacidade
                  </button>
                  .
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-2 sm:shrink-0">
                <button
                  type="button"
                  onClick={() => setShowTerms(true)}
                  className="rounded-xl border border-[#0877c5]/25 px-5 py-2.5 text-sm font-medium text-[#0877c5] hover:bg-[#0877c5]/5 transition-colors"
                >
                  Saiba mais
                </button>
                <button
                  type="button"
                  onClick={handleAccept}
                  className="rounded-xl bg-gradient-to-r from-[#0877c5] to-[#b51625] px-5 py-2.5 text-sm font-semibold text-white hover:opacity-95 transition-opacity"
                >
                  Aceitar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showTerms && (
        <div
          className="fixed inset-0 z-[80] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
          onClick={() => setShowTerms(false)}
          role="presentation"
        >
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="terms-title"
            className="w-full max-w-lg max-h-[85vh] overflow-y-auto rounded-2xl bg-white shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="h-2 bg-gradient-to-r from-[#0877c5] via-[#b51625] to-[#f3eb03]" />
            <div className="p-6 sm:p-8">
              <h2 id="terms-title" className="text-xl font-bold text-gray-900 mb-4">
                Termos de Uso e Privacidade
              </h2>
              <div className="space-y-4 text-sm text-gray-600 leading-relaxed">
                <p>
                  Ao utilizar o site da Art Custom, você concorda com a coleta e o uso de
                  informações conforme descrito abaixo, em conformidade com a Lei Geral de
                  Proteção de Dados (LGPD).
                </p>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Cookies</h3>
                  <p>
                    Usamos cookies e tecnologias semelhantes para lembrar preferências,
                    manter sessões e entender como o site é utilizado. Você pode gerenciar
                    cookies nas configurações do seu navegador.
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Dados coletados</h3>
                  <p>
                    Ao solicitar orçamento, podemos coletar nome, e-mail, telefone e
                    quantidade de peças para entrar em contato e prestar nossos serviços.
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Uso das informações</h3>
                  <p>
                    Os dados são utilizados exclusivamente para atendimento comercial,
                    comunicação sobre orçamentos e melhoria dos nossos serviços. Não
                    vendemos suas informações a terceiros.
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-1">Seus direitos</h3>
                  <p>
                    Você pode solicitar acesso, correção ou exclusão dos seus dados entrando
                    em contato conosco pelos canais disponíveis no site.
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={handleAccept}
                className="mt-6 w-full rounded-xl bg-gradient-to-r from-[#0877c5] to-[#b51625] py-3 text-sm font-semibold text-white hover:opacity-95 transition-opacity"
              >
                Li e aceito
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default CookieConsent
